import { useContext } from "react";

import { CompanyContext } from "../../../../components/CompanyList/CompanyContext";
import { CalendarIcon } from "../../../assets/CalendarIcon";
import { ClockIcon } from "../../../assets/ClockIcon";
import { CreditScoreGaugeIcon } from "../../../assets/CreditScoreGaugeIcon";
import { HandIcon } from "../../../assets/HandIcon";

export const FooterColumns = () => {
	const { company } = useContext(CompanyContext);
	const loanAmount = company?.fields?.loanAmount ?? null;
	const monthlyRevenue = company?.fields?.monthlyRevenue ?? null;
	const timeInBusiness = company?.fields?.timeInBusiness ?? null;
	const minCreditScore = company?.fields?.minCreditScore ?? null;

	return (
		<div className="tw:h-auto tw:w-full tw:rounded-[12px] tw:shadow-[0_0_2px_0_rgba(24,39,75,0.18),0_6px_12px_-6px_rgba(24,39,75,0.12),0_8px_24px_-4px_rgba(24,39,75,0.08)] tw:lg:h-10">
			<div className="tw:grid tw:grid-cols-2 tw:gap-x-4 tw:gap-y-2 tw:px-3 tw:py-2 tw:lg:flex tw:lg:h-full tw:lg:items-center tw:lg:justify-evenly tw:lg:py-1 tw:lg:pr-2 tw:lg:pl-8 tw:xl:px-0 tw:xl:py-0">
				{/* 1: Loan Amount */}
				<div className="tw:flex tw:lg:items-start tw:xl:items-center">
					<HandIcon className="tw:h-5 tw:w-auto" />
					<p className="tw:ml-1 tw:font-elza tw:text-[13px] tw:text-[#212121]">
						Loan Amount
						<span className="tw:ml-[2px] tw:block tw:font-medium tw:lg:inline-block tw:xl:inline">
							{loanAmount}
						</span>
					</p>
				</div>

				<div className="tw:hidden tw:h-[20px] tw:w-[2px] tw:bg-[#E6E6E6] tw:lg:block" />

				{/* 2: Monthly Revenue */}
				<div className="tw:flex tw:lg:items-start tw:xl:items-center">
					<CalendarIcon className="tw:h-5 tw:w-auto" />
					<p className="tw:ml-1 tw:font-elza tw:text-[13px] tw:text-[#212121]">
						Monthly Revenue{" "}
						<span className="tw:ml-[2px] tw:block tw:font-medium tw:lg:inline-block tw:xl:inline">
							{monthlyRevenue}
						</span>
					</p>
				</div>

				<div className="tw:hidden tw:h-[20px] tw:w-[2px] tw:bg-[#E6E6E6] tw:lg:block" />

				{/* 3: Time in Business */}
				<div className="tw:flex tw:lg:items-start tw:xl:items-center">
					<ClockIcon useGradient className="tw:h-4 tw:w-auto" />
					<p className="tw:ml-1 tw:font-elza tw:text-[13px] tw:text-[#212121]">
						Time in Business{" "}
						<span className="tw:ml-[2px] tw:block tw:font-medium tw:lg:inline-block tw:xl:inline">
							{timeInBusiness}
						</span>
					</p>
				</div>

				<div className="tw:hidden tw:h-[20px] tw:w-[2px] tw:bg-[#E6E6E6] tw:lg:block" />

				{/* 4: Credit Score */}
				<div className="tw:flex tw:lg:items-start tw:xl:items-center">
					<CreditScoreGaugeIcon className="tw:h-5 tw:w-auto" />
					<p className="tw:ml-1 tw:font-elza tw:text-[13px] tw:text-[#212121]">
						Min. Credit Score{" "}
						<span className="tw:ml-[2px] tw:block tw:font-medium tw:lg:inline-block tw:xl:inline">
							{minCreditScore}
						</span>
					</p>
				</div>
			</div>
		</div>
	);
};
